import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

// All translatable strings. Keys are flat, dot-namespaced.
// fr = source language, en = English.
const DICT = {
    fr: {
        // Common
        "common.loading": "Chargement...",
        "common.back": "Retour",
        "common.see_all": "Tout voir",
        "common.copy": "Copier",
        "common.copied": "Copié!",
        "common.tap_to_copy": "Tapez pour copier",
        "common.send": "Envoyer",
        "common.cancel": "Annuler",
        "common.confirm": "Confirmer",
        "common.delete": "Supprimer",
        "common.edit": "Modifier",
        "common.save": "Enregistrer",
        "common.optional": "(optionnel)",
        "common.required": "(obligatoire)",
        "common.yes": "Oui",
        "common.no": "Non",
        "common.no_data": "Aucune donnée pour le moment.",
        "common.coming_soon": "À venir",

        // Tournament base
        "tournament.name": "DÉFI ULTIME",
        "tournament.edition": "Édition 2026",
        "tournament.date": "4 juillet 2026",
        "tournament.tagline": "Le tournoi de dek hockey jeunesse le plus intense de l'année.",
        "tournament.sport": "Dek hockey",
        "tournament.arena": "Dek Hockey Cowansville",

        // Navigation
        "nav.infos": "Infos",
        "nav.infos_practical": "Infos pratiques",
        "nav.inscription": "Inscription",
        "nav.schedule": "Horaire",
        "nav.teams": "Équipes",
        "nav.stats": "Statistiques",
        "nav.standings": "Classement",
        "nav.scorers": "Pointeurs",
        "nav.playoffs": "Éliminatoires",
        "nav.news": "Nouvelles",
        "nav.gallery": "Galerie",
        "nav.partners": "Partenaires",
        "nav.rules": "Règlements",
        "nav.contact": "Contact",
        "nav.admin": "Admin",
        "nav.menu": "Menu",

        // Footer
        "footer.navigation": "Navigation",
        "footer.tournament": "Tournoi",
        "footer.follow": "Suivez-nous",
        "footer.rights": "Tous droits réservés.",
        "footer.crafted_with": "Conçu avec",
        "footer.love": "amour",
        "footer.by": "par",
        "footer.samourai": "le Samouraï du Web",
        "footer.lang": "Langue",

        // Home
        "home.kicker_about": "À propos",
        "home.hero_subtitle": "Une journée d'action intense de dek hockey. Les meilleures équipes M11, M13, M15 et M18 Open s'affrontent pour le titre suprême au Dek Hockey Cowansville.",
        "home.cta_inscrire": "Inscrire mon équipe",
        "home.cta_horaire": "Voir l'horaire",
        "home.stat_date": "Date",
        "home.stat_lieu": "Lieu",
        "home.stat_categories": "Catégories",
        "home.scroll_discover": "Défilez pour découvrir",
        "home.live_kicker": "Action en cours",
        "home.live_title": "Parties",
        "home.live_accent": "EN DIRECT",
        "home.about_title_pre": "Le tournoi le plus",
        "home.about_title_accent": "intense",
        "home.about_title_post": "de la saison",
        "home.about_body": "{name} rassemble les meilleurs jeunes joueurs de dek hockey du Québec au Dek Hockey Cowansville. Une journée non-stop, deux surfaces, une seule chose en tête : remporter la finale.",
        "home.about_badge_top": "1 JOURNÉE",
        "home.about_badge_bottom": "d'action intense de dek hockey",
        "home.finals_kicker": "Phases finales",
        "home.finals_title": "Finales en",
        "home.finals_accent": "vedette",
        "home.semifinal": "DEMI-FINALE",
        "home.final_d2": "FINALE D2",
        "home.final_d3": "FINALE D3",
        "home.news_kicker": "Actualités",
        "home.news_title": "Dernières",
        "home.news_accent": "nouvelles",
        "home.partners_kicker": "Merci à nos",
        "home.partners_title": "Partenaires",

        // Schedule
        "schedule.title_pre": "Horaire",
        "schedule.title_accent": "complet",
        "schedule.kicker": "Tournoi 2026",
        "schedule.filters": "FILTRES",
        "schedule.all_surfaces": "Toutes les surfaces",
        "schedule.all_categories": "Toutes catégories",
        "schedule.no_games": "Aucune partie pour les filtres choisis.",
        "schedule.col_game": "#",
        "schedule.col_time": "Heure",
        "schedule.col_surface": "Surface",
        "schedule.col_category": "Catégorie",
        "schedule.col_teams": "Équipes",
        "schedule.col_score": "Score",
        "schedule.col_status": "Statut",
        "schedule.vs": "vs",

        // Teams
        "teams.kicker": "Participantes",
        "teams.title_pre": "Les",
        "teams.title_accent": "équipes",
        "teams.coming_label": "À VENIR",
        "teams.reveal_body_pre": "Les équipes participantes seront",
        "teams.reveal_body_highlight": "dévoilées 1 semaine avant l'événement",
        "teams.reveal_body_post": "soit à partir du",
        "teams.reveal_body_date": "27 juin 2026",
        "teams.reveal_body_tail": "Restez à l'affût !",
        "teams.reveal_full": "La liste complète des équipes participantes sera affichée le 27 juin 2026.",
        "teams.category_label": "Catégorie",
        "teams.born_in": "Né en",
        "teams.count_suffix": "équipes",
        "teams.see_roster": "Voir le roster →",
        "teams.all_teams": "Toutes les équipes",
        "teams.roster": "Roster",
        "teams.no_roster": "Aucun joueur pour le moment.",
        "team.schedule": "Calendrier de l'équipe",

        // Standings
        "standings.kicker": "Classement",
        "standings.title_pre": "Tableau",
        "standings.title_accent": "des forces",
        "standings.pool_a": "POULE A (Top)",
        "standings.pool_b": "POULE B",
        "standings.legend_title": "Légende & bris d'égalité",
        "standings.col_rank": "#",
        "standings.col_team": "Équipe",
        "standings.col_played": "PJ",
        "standings.col_wins": "V",
        "standings.col_losses": "D",
        "standings.col_ties": "N",
        "standings.col_pts": "PTS",
        "standings.col_gf": "BP",
        "standings.col_ga": "BC",
        "standings.col_diff": "DIFF",
        "standings.col_pim": "PUN",
        "standings.no_data": "Le classement sera disponible quand des parties auront été jouées.",

        // Scorers
        "scorers.kicker": "Stats joueurs",
        "scorers.title_pre": "Meilleurs",
        "scorers.title_accent": "pointeurs",
        "scorers.col_rank": "#",
        "scorers.col_player": "Joueur",
        "scorers.col_team": "Équipe",
        "scorers.col_goals": "B",
        "scorers.col_assists": "A",
        "scorers.col_points": "PTS",
        "scorers.col_pim": "PUN",
        "scorers.no_data": "Aucune statistique enregistrée pour le moment.",
        "scorers.stats_hidden": "Les statistiques détaillées seront publiées après le tournoi.",

        // Playoffs bracket
        "playoffs.kicker": "Séries",
        "playoffs.title_pre": "Arbre des",
        "playoffs.title_accent": "éliminatoires",
        "playoffs.no_games": "Le tableau des séries sera dévoilé une fois la phase préliminaire terminée.",
        "playoffs.phase.quart": "Quart de finale",
        "playoffs.phase.demi": "Demi-finale",
        "playoffs.phase.finale": "Finale",
        "playoffs.phase.finale_d2": "Finale D2",
        "playoffs.phase.finale_d3": "Finale D3",
        "playoffs.phase.elim": "Éliminatoire",
        "playoffs.tbd": "À déterminer",
        "playoffs.winner": "Champion",
        "playoffs.game_num": "Partie",
        "playoffs.final_score": "Final",
        "playoffs.live_now": "EN COURS",

        // News
        "news.kicker": "Actualités",
        "news.title_pre": "Toutes les",
        "news.title_accent": "nouvelles",
        "news.no_news": "Aucune nouvelle pour le moment.",
        "news.read_more": "Lire la suite →",
        "news.published_on": "Publié le",
        "news.back_to_news": "Toutes les nouvelles",

        // Gallery
        "gallery.kicker": "Photos",
        "gallery.title_pre": "Galerie",
        "gallery.title_accent": "tournoi",
        "gallery.no_photos": "La galerie sera remplie pendant et après le tournoi.",
        "gallery.drive_cta_title": "Galerie complète",
        "gallery.drive_cta_desc": "Découvrez toutes les photos du tournoi en haute résolution.",
        "gallery.drive_cta_btn": "Voir toutes les photos",

        // Partners
        "partners.kicker": "Ils soutiennent le tournoi",
        "partners.title_pre": "Nos",
        "partners.title_accent": "partenaires",
        "partners.platinum": "Platine",
        "partners.gold": "Or",
        "partners.silver": "Argent",
        "partners.bronze": "Bronze",
        "partners.empty": "Vous voulez devenir partenaire ? Écrivez-nous depuis la page Contact.",

        // Rules
        "rules.kicker": "Tournoi",
        "rules.title_pre": "Règlements",
        "rules.title_accent": "officiels",
        "rules.cats_label": "Catégories & années de naissance admissibles",
        "rules.cats_heading": "Vérifiez votre catégorie",
        "rules.born_in": "Né en",
        "rules.cats_footer": "L'âge du joueur est calculé au 31 décembre de l'année du tournoi. Exception : une équipe féminine peut évoluer dans une catégorie inférieure. En cas de doute, contactez l'organisation.",
        "rules.format_label": "Format de jeu",
        "rules.format_body": "Dek hockey rapide, en continu, sur 2 périodes de 12 minutes.",
        "rules.article": "Article",
        "rules.r1_title": "Format du tournoi",
        "rules.r1_body": "Le Défi Ultime se joue en format 3 contre 3. Action rapide et continue, idéale pour le dek hockey.",
        "rules.r2_title": "Réchauffement",
        "rules.r2_body": "Un réchauffement de 2 minutes est offert avant chaque partie.",
        "rules.r3_title": "Durée des parties",
        "rules.r3_body": "Toutes les parties sont de 2 périodes de 12 minutes (chrono continu).",
        "rules.r4_title": "Égalité en préliminaires",
        "rules.r4_body": "Si le score est égal à la fin du temps réglementaire en ronde préliminaire, la partie se termine sur une égalité (1 point au classement par équipe).",
        "rules.r5_title": "Égalité en éliminatoires",
        "rules.r5_body": "Si égalité à la fin du temps réglementaire en match éliminatoire : prolongation de 3 minutes (mort subite), puis tirs de barrage si toujours égalité.",
        "rules.r6_title": "Formation des équipes",
        "rules.r6_body": "Alignement maximum : 9 joueurs + 1 gardien. Format de jeu sur la surface : 3 contre 3.",
        "rules.r7_title": "Écart de buts",
        "rules.r7_body": "Le différentiel de buts est plafonné à ±7 par partie pour le calcul du classement. La partie peut continuer même s'il y a un écart de 7 buts, si les arbitres jugent que la partie ne comporte pas de risque de débordement. Si la partie risque de déborder, alors après 7 buts d'écart et 1 période de jeu, les arbitres peuvent mettre fin à la partie.",
        "rules.r8_title": "Pénalités",
        "rules.r8_body": "Mineure = 1 minute ; majeure = 3 minutes ; inconduite = 10 minutes ; match = renvoi automatique. Toute pénalité majeure entraîne une révision par le comité de discipline.",
        "rules.r9_title": "Bris d'égalité au classement",
        "rules.r9_body": "1) Plus de victoires ; 2) Moins de défaites ; 3) Différentiel capé ±7 par partie ; 4) Face-à-face (si applicable) ; 5) Plus de buts pour ; 6) Moins de buts contre ; 7) Tirage au sort.",
        "rules.r10_title": "Conduite",
        "rules.r10_body": "L'esprit sportif est obligatoire. Tout comportement antisportif des joueurs, entraîneurs ou parents pourra entraîner expulsion immédiate du tournoi.",
        "rules.r11_title": "Décisions des officiels",
        "rules.r11_body": "Les décisions des officiels sont finales et sans appel. Le comité du tournoi se réserve le droit de modifier l'horaire au besoin.",
        "rules.r12_title": "Lieu",
        "rules.r12_body": "Toutes les parties se déroulent au Dek Hockey Cowansville (200 Rue Christophe-Colomb, Cowansville, QC J2K 1G7) sur les surfaces 1 et 2.",

        // Info
        "info.kicker": "Sur place",
        "info.title_pre": "Infos",
        "info.title_accent": "pratiques",
        "info.site_title": "Site du tournoi",
        "info.site_surfaces": "2 surfaces de dek hockey",
        "info.food_title": "Restauration",
        "info.food_body": "Cantine ouverte le jour du tournoi. Menu chaud disponible : pizza, hot-dogs, poutines. Café, boissons fraîches et collations également offerts.",

        // Contact
        "contact.kicker": "Restons en contact",
        "contact.title": "Contact",
        "contact.email_heading": "Courriel",
        "contact.email_body": "Pour toute demande de partenariat, inscription, question ou commentaire, écrivez-nous à l'adresse ci-dessous.",
        "contact.see_email": "Voir le courriel",
        "contact.open_mail_app": "Ouvrir mon application courriel",
        "contact.follow": "Suivez-nous",
        "contact.follow_footer": "Restez informés des prochaines annonces du tournoi.",

        // Inscription
        "inscription.kicker": "Tournoi 2026",
        "inscription.title_pre": "Inscription",
        "inscription.title_accent": "d'équipe",
        "inscription.fee_label": "Frais d'inscription",
        "inscription.fee_sub": "payable par virement Interac",
        "inscription.interac_title": "Paiement par virement Interac",
        "inscription.interac_lead": "Effectuez votre virement Interac depuis votre application bancaire avec les informations suivantes :",
        "inscription.interac_email_label": "Adresse courriel · tapez pour copier",
        "inscription.interac_answer_label": "Réponse à la question · tapez pour copier",
        "inscription.interac_message_label": "Message / commentaire",
        "inscription.interac_message_format": "Format : nom de l'équipe - catégorie",
        "inscription.interac_safe": "Votre inscription sera confirmée dès que nous aurons reçu le virement. Vous recevrez un courriel de confirmation.",
        "inscription.categories_avail": "Catégories disponibles",
        "inscription.location": "Lieu",
        "inscription.lineup": "Alignement",
        "inscription.lineup_max": "Maximum 9 joueurs + 1 gardien par équipe",
        "inscription.form_lead": "Remplissez le formulaire ci-dessous, puis effectuez votre virement Interac avec les informations affichées à gauche.",
        "inscription.team_name": "Nom de l'équipe",
        "inscription.team_name_placeholder": "Ex: Les Foudres Cowansville",
        "inscription.category": "Catégorie",
        "inscription.birth_year": "Année de naissance",
        "inscription.city": "Ville",
        "inscription.city_placeholder": "Ex: Cowansville",
        "inscription.manager": "Nom du responsable",
        "inscription.email": "Courriel",
        "inscription.phone": "Téléphone",
        "inscription.total": "Total à payer par Interac",
        "inscription.submit": "Confirmer mon inscription",
        "inscription.submitting": "Envoi...",
        "inscription.footer_note": "En confirmant, vous recevrez les instructions de paiement Interac et nous vérifierons votre virement manuellement.",
        "inscription.success_title": "Inscription reçue !",
        "inscription.success_body": "Merci pour votre inscription. Effectuez votre virement Interac avec les informations fournies. Nous vous confirmerons par courriel dès réception.",
        "inscription.closed_title": "Inscriptions fermées",
        "inscription.closed_body": "Les inscriptions au tournoi Défi Ultime sont actuellement fermées. Revenez bientôt ou contactez-nous pour plus d'informations.",

        // Status
        "status.scheduled": "À venir",
        "status.live": "EN DIRECT",
        "status.final": "Final",

        // Team login
        "team_login.title": "Espace équipe",
        "team_login.missing_token": "Aucun jeton d'accès fourni dans l'URL.",
        "team_login.invalid_token": "Lien expiré ou invalide. Demandez un nouveau lien à l'administration.",
        "team_login.welcome": "Bienvenue ! Redirection vers votre tableau de bord...",
        "team_login.error_label": "Accès refusé",
        "team_login.contact_admin": "Contacter l'administration",

        // Team dashboard
        "team_dash.title": "Mon équipe",
        "team_dash.manager": "Responsable",
        "team_dash.logout": "Déconnexion",
        "team_dash.roster": "Alignement",
        "team_dash.add_player": "Ajouter un joueur",
        "team_dash.empty_roster": "Aucun joueur encore. Cliquez sur « Ajouter un joueur » pour commencer.",
        "team_dash.edit_player": "Modifier le joueur",
        "team_dash.new_player": "Nouveau joueur",
        "team_dash.limit_reached": "Limite atteinte : 10 joueurs maximum (9 + 1 gardien).",
        "team_dash.number": "Numéro",
        "team_dash.position": "Position",
        "team_dash.position_ph": "Avant, défense, gardien...",
        "team_dash.first_name": "Prénom",
        "team_dash.last_name": "Nom",
        "team_dash.dob": "Date de naissance",
        "team_dash.dob_short": "Né le",
        "team_dash.dob_format": "AAAA-MM-JJ",
        "team_dash.nbhpa": "Lien passeport NBHPA",
        "team_dash.photo": "Photo du joueur",
        "team_dash.take_photo": "Prendre une photo",
        "team_dash.choose_file": "Choisir une image",
        "team_dash.remove_photo": "Retirer la photo",
        "team_dash.add": "Ajouter",
        "team_dash.saving": "Enregistrement...",
        "team_dash.photo_err": "Impossible de lire cette image.",
        "team_dash.save_err": "Erreur lors de la sauvegarde.",
        "team_dash.delete_confirm": "Supprimer {name} de l'alignement ?",
        "team_dash.no_team": "Équipe introuvable.",
    },

    en: {
        // Common
        "common.loading": "Loading...",
        "common.back": "Back",
        "common.see_all": "See all",
        "common.copy": "Copy",
        "common.copied": "Copied!",
        "common.tap_to_copy": "Tap to copy",
        "common.send": "Send",
        "common.cancel": "Cancel",
        "common.confirm": "Confirm",
        "common.delete": "Delete",
        "common.edit": "Edit",
        "common.save": "Save",
        "common.optional": "(optional)",
        "common.required": "(required)",
        "common.yes": "Yes",
        "common.no": "No",
        "common.no_data": "No data yet.",
        "common.coming_soon": "Coming soon",

        // Tournament base
        "tournament.name": "DÉFI ULTIME",
        "tournament.edition": "2026 Edition",
        "tournament.date": "July 4, 2026",
        "tournament.tagline": "The most intense youth dek hockey tournament of the year.",
        "tournament.sport": "Dek hockey",
        "tournament.arena": "Dek Hockey Cowansville",

        // Navigation
        "nav.infos": "Info",
        "nav.infos_practical": "Practical info",
        "nav.inscription": "Register",
        "nav.schedule": "Schedule",
        "nav.teams": "Teams",
        "nav.stats": "Statistics",
        "nav.standings": "Standings",
        "nav.scorers": "Scorers",
        "nav.playoffs": "Playoffs",
        "nav.news": "News",
        "nav.gallery": "Gallery",
        "nav.partners": "Partners",
        "nav.rules": "Rules",
        "nav.contact": "Contact",
        "nav.admin": "Admin",
        "nav.menu": "Menu",

        // Footer
        "footer.navigation": "Navigation",
        "footer.tournament": "Tournament",
        "footer.follow": "Follow us",
        "footer.rights": "All rights reserved.",
        "footer.crafted_with": "Crafted with",
        "footer.love": "love",
        "footer.by": "by",
        "footer.samourai": "le Samouraï du Web",
        "footer.lang": "Language",

        // Home
        "home.kicker_about": "About",
        "home.hero_subtitle": "A full day of intense dek hockey action. The best M11, M13, M15 and M18 Open teams battle for the ultimate title at Dek Hockey Cowansville.",
        "home.cta_inscrire": "Register my team",
        "home.cta_horaire": "View schedule",
        "home.stat_date": "Date",
        "home.stat_lieu": "Venue",
        "home.stat_categories": "Categories",
        "home.scroll_discover": "Scroll to discover",
        "home.live_kicker": "Action happening now",
        "home.live_title": "Games",
        "home.live_accent": "LIVE",
        "home.about_title_pre": "The most",
        "home.about_title_accent": "intense",
        "home.about_title_post": "tournament of the season",
        "home.about_body": "{name} brings together the best youth dek hockey players in Quebec at Dek Hockey Cowansville. One non-stop day, two surfaces, one goal in mind: winning the final.",
        "home.about_badge_top": "1 DAY",
        "home.about_badge_bottom": "of intense dek hockey action",
        "home.finals_kicker": "Playoff phase",
        "home.finals_title": "Featured",
        "home.finals_accent": "finals",
        "home.semifinal": "SEMI-FINAL",
        "home.final_d2": "FINAL D2",
        "home.final_d3": "FINAL D3",
        "home.news_kicker": "News",
        "home.news_title": "Latest",
        "home.news_accent": "stories",
        "home.partners_kicker": "Thank you to our",
        "home.partners_title": "Partners",

        // Schedule
        "schedule.title_pre": "Full",
        "schedule.title_accent": "schedule",
        "schedule.kicker": "2026 Tournament",
        "schedule.filters": "FILTERS",
        "schedule.all_surfaces": "All surfaces",
        "schedule.all_categories": "All categories",
        "schedule.no_games": "No games match the selected filters.",
        "schedule.col_game": "#",
        "schedule.col_time": "Time",
        "schedule.col_surface": "Surface",
        "schedule.col_category": "Category",
        "schedule.col_teams": "Teams",
        "schedule.col_score": "Score",
        "schedule.col_status": "Status",
        "schedule.vs": "vs",

        // Teams
        "teams.kicker": "Participating",
        "teams.title_pre": "The",
        "teams.title_accent": "teams",
        "teams.coming_label": "COMING SOON",
        "teams.reveal_body_pre": "Participating teams will be",
        "teams.reveal_body_highlight": "revealed 1 week before the event",
        "teams.reveal_body_post": "starting on",
        "teams.reveal_body_date": "June 27, 2026",
        "teams.reveal_body_tail": "Stay tuned!",
        "teams.reveal_full": "The full list of participating teams will be displayed on June 27, 2026.",
        "teams.category_label": "Category",
        "teams.born_in": "Born in",
        "teams.count_suffix": "teams",
        "teams.see_roster": "View roster →",
        "teams.all_teams": "All teams",
        "teams.roster": "Roster",
        "teams.no_roster": "No players yet.",
        "team.schedule": "Team schedule",

        // Standings
        "standings.kicker": "Standings",
        "standings.title_pre": "League",
        "standings.title_accent": "table",
        "standings.pool_a": "POOL A (Top)",
        "standings.pool_b": "POOL B",
        "standings.legend_title": "Legend & tiebreakers",
        "standings.col_rank": "#",
        "standings.col_team": "Team",
        "standings.col_played": "GP",
        "standings.col_wins": "W",
        "standings.col_losses": "L",
        "standings.col_ties": "T",
        "standings.col_pts": "PTS",
        "standings.col_gf": "GF",
        "standings.col_ga": "GA",
        "standings.col_diff": "DIFF",
        "standings.col_pim": "PIM",
        "standings.no_data": "Standings will be available once games are played.",

        // Scorers
        "scorers.kicker": "Player stats",
        "scorers.title_pre": "Top",
        "scorers.title_accent": "scorers",
        "scorers.col_rank": "#",
        "scorers.col_player": "Player",
        "scorers.col_team": "Team",
        "scorers.col_goals": "G",
        "scorers.col_assists": "A",
        "scorers.col_points": "PTS",
        "scorers.col_pim": "PIM",
        "scorers.no_data": "No statistics recorded yet.",
        "scorers.stats_hidden": "Detailed statistics will be published after the tournament.",

        // Playoffs bracket
        "playoffs.kicker": "Playoffs",
        "playoffs.title_pre": "The",
        "playoffs.title_accent": "bracket",
        "playoffs.no_games": "The playoff bracket will be unveiled once the round-robin is complete.",
        "playoffs.phase.quart": "Quarter-final",
        "playoffs.phase.demi": "Semi-final",
        "playoffs.phase.finale": "Final",
        "playoffs.phase.finale_d2": "Final D2",
        "playoffs.phase.finale_d3": "Final D3",
        "playoffs.phase.elim": "Playoff",
        "playoffs.tbd": "TBD",
        "playoffs.winner": "Champion",
        "playoffs.game_num": "Game",
        "playoffs.final_score": "Final",
        "playoffs.live_now": "LIVE",

        // News
        "news.kicker": "News",
        "news.title_pre": "All",
        "news.title_accent": "stories",
        "news.no_news": "No stories yet.",
        "news.read_more": "Read more →",
        "news.published_on": "Published on",
        "news.back_to_news": "All stories",

        // Gallery
        "gallery.kicker": "Photos",
        "gallery.title_pre": "Tournament",
        "gallery.title_accent": "gallery",
        "gallery.no_photos": "The gallery will be filled during and after the tournament.",
        "gallery.drive_cta_title": "Full gallery",
        "gallery.drive_cta_desc": "Browse every high-resolution photo from the tournament.",
        "gallery.drive_cta_btn": "View all photos",

        // Partners
        "partners.kicker": "They support the tournament",
        "partners.title_pre": "Our",
        "partners.title_accent": "partners",
        "partners.platinum": "Platinum",
        "partners.gold": "Gold",
        "partners.silver": "Silver",
        "partners.bronze": "Bronze",
        "partners.empty": "Want to become a partner? Reach out from the Contact page.",

        // Rules
        "rules.kicker": "Tournament",
        "rules.title_pre": "Official",
        "rules.title_accent": "rules",
        "rules.cats_label": "Categories & eligible birth years",
        "rules.cats_heading": "Check your category",
        "rules.born_in": "Born in",
        "rules.cats_footer": "Player age is calculated as of December 31 of the tournament year. Exception: a female team may play in a lower category. Contact the organization if in doubt.",
        "rules.format_label": "Game format",
        "rules.format_body": "Fast continuous dek hockey, 2 periods of 12 minutes.",
        "rules.article": "Article",
        "rules.r1_title": "Tournament format",
        "rules.r1_body": "The Défi Ultime is played 3 vs 3. Fast, continuous action — perfect for dek hockey.",
        "rules.r2_title": "Warm-up",
        "rules.r2_body": "A 2-minute warm-up is provided before every game.",
        "rules.r3_title": "Game duration",
        "rules.r3_body": "All games are 2 periods of 12 minutes (running clock).",
        "rules.r4_title": "Ties in preliminaries",
        "rules.r4_body": "If the score is tied at the end of regulation in the preliminary round, the game ends in a tie (1 standings point per team).",
        "rules.r5_title": "Ties in playoffs",
        "rules.r5_body": "If tied at the end of regulation in a playoff game: 3-minute sudden-death overtime, then a shootout if still tied.",
        "rules.r6_title": "Team composition",
        "rules.r6_body": "Maximum lineup: 9 players + 1 goalie. On-surface format: 3 vs 3.",
        "rules.r7_title": "Goal differential",
        "rules.r7_body": "Goal differential is capped at ±7 per game for standings. The game may continue even with a 7-goal gap if the referees judge there is no risk of losing control. If the game risks getting out of hand, the referees may end it after a 7-goal gap and 1 full period.",
        "rules.r8_title": "Penalties",
        "rules.r8_body": "Minor = 1 minute; major = 3 minutes; misconduct = 10 minutes; game misconduct = automatic ejection. Any major penalty triggers a review by the discipline committee.",
        "rules.r9_title": "Standings tiebreakers",
        "rules.r9_body": "1) Most wins; 2) Fewest losses; 3) Capped differential ±7 per game; 4) Head-to-head (if applicable); 5) Most goals for; 6) Fewest goals against; 7) Random draw.",
        "rules.r10_title": "Conduct",
        "rules.r10_body": "Sportsmanship is mandatory. Any unsportsmanlike behavior from players, coaches or parents may result in immediate expulsion.",
        "rules.r11_title": "Officials' decisions",
        "rules.r11_body": "Officials' decisions are final and binding. The tournament committee reserves the right to modify the schedule as needed.",
        "rules.r12_title": "Venue",
        "rules.r12_body": "All games are played at Dek Hockey Cowansville (200 Rue Christophe-Colomb, Cowansville, QC J2K 1G7) on surfaces 1 and 2.",

        // Info
        "info.kicker": "On site",
        "info.title_pre": "Practical",
        "info.title_accent": "info",
        "info.site_title": "Tournament venue",
        "info.site_surfaces": "2 dek hockey surfaces",
        "info.food_title": "Food & drinks",
        "info.food_body": "The canteen is open on tournament day. Hot menu available: pizza, hot dogs, poutine. Coffee, cold drinks and snacks are also offered.",

        // Contact
        "contact.kicker": "Get in touch",
        "contact.title": "Contact",
        "contact.email_heading": "Email",
        "contact.email_body": "For sponsorship, registration, questions or comments, write to the address below.",
        "contact.see_email": "Reveal email",
        "contact.open_mail_app": "Open my mail app",
        "contact.follow": "Follow us",
        "contact.follow_footer": "Stay tuned for tournament announcements.",

        // Inscription
        "inscription.kicker": "2026 Tournament",
        "inscription.title_pre": "Team",
        "inscription.title_accent": "registration",
        "inscription.fee_label": "Registration fee",
        "inscription.fee_sub": "payable by Interac e-Transfer",
        "inscription.interac_title": "Payment by Interac e-Transfer",
        "inscription.interac_lead": "Send your Interac transfer from your banking app using the following information:",
        "inscription.interac_email_label": "Email address · tap to copy",
        "inscription.interac_answer_label": "Security answer · tap to copy",
        "inscription.interac_message_label": "Message / memo",
        "inscription.interac_message_format": "Format: team name - category",
        "inscription.interac_safe": "Your registration will be confirmed once we receive the transfer. You will receive an email confirmation.",
        "inscription.categories_avail": "Available categories",
        "inscription.location": "Venue",
        "inscription.lineup": "Lineup",
        "inscription.lineup_max": "Maximum 9 players + 1 goalie per team",
        "inscription.form_lead": "Fill out the form below, then send your Interac transfer using the information on the left.",
        "inscription.team_name": "Team name",
        "inscription.team_name_placeholder": "Ex: Cowansville Thunder",
        "inscription.category": "Category",
        "inscription.birth_year": "Birth year",
        "inscription.city": "City",
        "inscription.city_placeholder": "Ex: Cowansville",
        "inscription.manager": "Manager name",
        "inscription.email": "Email",
        "inscription.phone": "Phone",
        "inscription.total": "Total payable by Interac",
        "inscription.submit": "Confirm my registration",
        "inscription.submitting": "Sending...",
        "inscription.footer_note": "By confirming, you'll receive Interac payment instructions and we'll verify your transfer manually.",
        "inscription.success_title": "Registration received!",
        "inscription.success_body": "Thank you for registering. Send your Interac transfer using the provided info. We'll confirm by email upon receipt.",
        "inscription.closed_title": "Registrations closed",
        "inscription.closed_body": "Registrations for the Défi Ultime tournament are currently closed. Please check back soon or contact us for more information.",

        // Status
        "status.scheduled": "Upcoming",
        "status.live": "LIVE",
        "status.final": "Final",

        // Team login
        "team_login.title": "Team area",
        "team_login.missing_token": "No access token provided in the URL.",
        "team_login.invalid_token": "Link expired or invalid. Ask administration for a new link.",
        "team_login.welcome": "Welcome! Redirecting to your dashboard...",
        "team_login.error_label": "Access denied",
        "team_login.contact_admin": "Contact administration",

        // Team dashboard
        "team_dash.title": "My team",
        "team_dash.manager": "Manager",
        "team_dash.logout": "Sign out",
        "team_dash.roster": "Roster",
        "team_dash.add_player": "Add a player",
        "team_dash.empty_roster": "No players yet. Click \"Add a player\" to get started.",
        "team_dash.edit_player": "Edit player",
        "team_dash.new_player": "New player",
        "team_dash.limit_reached": "Limit reached: 10 players max (9 + 1 goalie).",
        "team_dash.number": "Number",
        "team_dash.position": "Position",
        "team_dash.position_ph": "Forward, defense, goalie...",
        "team_dash.first_name": "First name",
        "team_dash.last_name": "Last name",
        "team_dash.dob": "Date of birth",
        "team_dash.dob_short": "Born",
        "team_dash.dob_format": "YYYY-MM-DD",
        "team_dash.nbhpa": "NBHPA passport link",
        "team_dash.photo": "Player photo",
        "team_dash.take_photo": "Take a photo",
        "team_dash.choose_file": "Choose an image",
        "team_dash.remove_photo": "Remove photo",
        "team_dash.add": "Add",
        "team_dash.saving": "Saving...",
        "team_dash.photo_err": "Could not read this image.",
        "team_dash.save_err": "Save failed.",
        "team_dash.delete_confirm": "Remove {name} from the roster?",
        "team_dash.no_team": "Team not found.",
    },
};

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

function detectInitialLang() {
    try {
        const stored = window.localStorage.getItem("du_lang");
        if (stored === "fr" || stored === "en") return stored;
    } catch { /* ignore */ }
    try {
        const nav = (window.navigator.language || "fr").toLowerCase();
        return nav.startsWith("en") ? "en" : "fr";
    } catch {
        return "fr";
    }
}

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => detectInitialLang());
    const setLang = (l) => {
        if (l !== "fr" && l !== "en") return;
        setLangState(l);
        try { window.localStorage.setItem("du_lang", l); } catch { /* ignore */ }
        try { document.documentElement.lang = l; } catch { /* ignore */ }
    };
    useEffect(() => {
        try { document.documentElement.lang = lang; } catch { /* ignore */ }
    }, [lang]);

    const t = useMemo(() => {
        return (key, vars) => {
            const dict = DICT[lang] || DICT.fr;
            let s = dict[key];
            if (s == null) {
                // fallback to French, then key itself
                s = (DICT.fr[key] != null) ? DICT.fr[key] : key;
            }
            if (vars && typeof s === "string") {
                Object.keys(vars).forEach((v) => {
                    s = s.replace(new RegExp(`\\{${v}\\}`, "g"), vars[v]);
                });
            }
            return s;
        };
    }, [lang]);

    const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useT() {
    return useContext(LangContext);
}

// Localized date helpers
export function formatDayLocalized(d, lang) {
    if (!d) return "";
    try {
        const dt = new Date(d + "T00:00:00");
        const loc = lang === "en" ? "en-CA" : "fr-CA";
        return dt.toLocaleDateString(loc, { weekday: "long", day: "numeric", month: "long" });
    } catch {
        return d;
    }
}
